import { endOfDay, format } from 'date-fns';

import type { LapPlatoonsConfigItem, LapProgramType, LapUpdateArgs } from '@modules/types/graphql';

export type UpdateLapFormValues = {
    programType: LapProgramType | '';
    from: Date | null;
    to: Date | null;
    platoonsCompanyCount: number;
    platoonsByCompanies: [number, string][];
};

class UpdateLapRequest {
    programType: LapUpdateArgs['programType'];
    from: LapUpdateArgs['from'];
    to: LapUpdateArgs['to'];
    platoonsConfig: LapUpdateArgs['platoonsConfig'];

    constructor(values: UpdateLapFormValues) {
        this.programType = (values.programType as LapProgramType) || undefined;
        this.from = values.from ? format(endOfDay(values.from), 'yyyy-MM-dd') : '';
        this.to = values.to ? format(endOfDay(values.to), 'yyyy-MM-dd') : '';

        this.platoonsConfig = values.platoonsByCompanies.reduce((carry, [company, platoons]) => {
            const item: LapPlatoonsConfigItem = {
                company,
                platoons: +platoons,
            };

            carry.push(item);

            return carry;
        }, [] as LapPlatoonsConfigItem[]);
    }
}

export { UpdateLapRequest };
